import React, { useEffect, useRef, useState } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import Cookies from "js-cookie";
import Header from "../components/layout/Header";
import Footer from "../components/layout/Footer";
import AnimatedRoutes from "./AnimatedRoutes";
import { getPageLoaderId, hidePageLoader, showPageLoader, waitForCurrentPageAssets } from "./pageLoadStatus";

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const initialLoaderId = useRef(null);
  const storedLang = Cookies.get("i18next");
  const [currentLang, setCurrentLang] = useState(storedLang || "en");

  useEffect(() => {
    const loader = document.getElementById("loader");

    if (loader) {
      initialLoaderId.current = showPageLoader();
    }

    waitForCurrentPageAssets().finally(() => setIsLoading(false));
  }, []);

  useEffect(() => {
    if (!isLoading) {
      hidePageLoader({ loaderId: initialLoaderId.current });
    }
  }, [isLoading]);

  useEffect(() => {
    if (!isLoading) {
      let isCancelled = false;

      const loaderId = getPageLoaderId();

      waitForCurrentPageAssets().then(() => {
        if (!isCancelled) {
          hidePageLoader({ loaderId });
        }
      });

      return () => {
        isCancelled = true;
      };
    }
  }, [currentLang, isLoading]);

  return (
    <Router>
      <Header currentLang={currentLang} storedLang={storedLang} setCurrentLang={setCurrentLang} />
      <AnimatedRoutes currentLang={currentLang} />
      <Footer />
    </Router>
  );
}

export default App;
